import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';

import { thanks, ThanksLinkData } from '../data/thanks';

const thanksBackground = {
  backgroundImage: `url(${process.env.PUBLIC_URL + '/img/thanks_background.jpg'})`,
};

export default class ThanksPage extends React.PureComponent<RouteComponentProps<{}>, {}> {
  thanksLink({ text, linkText, linkHref }: ThanksLinkData): JSX.Element {
    return (
      <p key={linkHref}>
        <span>{text}</span>
        <Link to={linkHref}>{linkText}</Link>
      </p>
    );
  }

  render(): JSX.Element {
    return (
      <div className="registry background" style={thanksBackground}>
        <section className="hero is-fullheight">
          <div className="hero-body">
            <div className="container">
              <div className="columns">
                <div className="column is-4">
                  <div className="box content">
                    <h1 className="title is-shadowed has-text-centered">{thanks.title}</h1>
                    {thanks.links.map(this.thanksLink)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/pages/thanks.tsx